import SimpleReadonlyModel from '../../classes/SimpleModel/SimpleReadonlyModel';

export default abstract class AbstractConfig<Config extends Record<string, any>> extends SimpleReadonlyModel<Config> {
}
